<template id="gatewayConfig">
  <div style="width: 100%;height: 100%;overflow: auto">
    
    <div ref="container"  style="width: fit-content; height: fit-content">
    </div>
  </div>
</template>

<script>

export default {
  name: "gatewayConfig",
  inject:{
    device: "device"
  },
  data(){
    return {
      container: undefined,
      extranetUIView: undefined,
      data: undefined,
      animationing: false,
      ipClone: true
    }
  },
  props: {
    initData: {},
    running: {},
    id: {
      type: Number,
      default: 0
    },
    extranetSetting:{},
    runningAnimation: {}
  },
  computed:{

    viewId(){
      return 'view'+this.id
    },

  },
  beforeDestroy: function (){
    this.extranetUIView.stop();
  },
  mounted: function () {
   this.init()//需要触发的函数

  },
  methods: {
    animationke(){
      this.animationing = true;
      if (this.extranetUIView){
        //this.extranetUIView.setRunningAnimation(true)
      }
    },
    unAnimationke(){
      this.animationing = false;
      if (this.extranetUIView){
        //this.extranetUIView.setRunningAnimation(false)
      }
    },
    init() {
      // let initdata = this.initData
      if(this.initData.local == undefined) {
        return
      }

      this.addData(this.initData);

    },
    addData(iData) {
      window.extranet.link.ui.languages.LocalInterfaceComment =
          "1、拖动本地接口，创建虚拟电缆，并将虚拟电缆拖动连接到对应的网关接口。\n" +
          "2、设置目标地址IP地址和虚拟IP地址，即可完成虚拟连接。\n" +
          "3、开启连接后可使用该虚拟IP地址访问目标设备。";

      window.extranet.link.ui.languages.DialogButtons.OK = "确定";
      window.extranet.link.ui.languages.DialogButtons.Cancel = "取消";
      window.extranet.link.ui.languages.DialogButtons.Delete = "删除";
      window.extranet.link.ui.languages.DialogButtons.Accept = "修改";

      window.extranet.link.ui.languages.NewDeviceDialog.Title = "映射设备地址";
      window.extranet.link.ui.languages.NewDeviceDialog.MapAddrLabel = "映射访问IP地址";
      window.extranet.link.ui.languages.NewDeviceDialog.LanAddrLabel = "实际目标IP地址";
      window.extranet.link.ui.languages.NewDeviceDialog.MemoLabel = "备注";

      window.extranet.link.ui.languages.EditDeviceDialog.Title = "修改设备地址";

      window.extranet.link.ui.languages.EditGWDialog.Title = "修改网关地址";
      window.extranet.link.ui.languages.EditGWDialog.AddrLabel = "网关虚拟地址";

      this.container = this.$refs.container;
      this.container.setAttribute("style",'background-color:white')

      this.data={
        ... iData
      }

      // this.extranetUIView.setAddEanble(true);
      // this.extranetUIView.setEditEanble(true);
      // this.extranetUIView.setDeleteEanble(true);

      if(this.extranetUIView){
        this.extranetUIView.stop();
        this.extranetUIView= undefined;
      }
      this.extranetUIView = new window.extranet.link.ui.view(this.container, this.data);

      this.extranetUIView.on('linkCreated',(e) => {

      })


      this.extranetUIView.on('added',(e) => {
        this.extranetUIView.setAddEanble(e < (this.extranetSetting.max || 0));
      })

      this.extranetUIView.on('deleted',(e) => {
        this.extranetUIView.setAddEanble(e < (this.extranetSetting.max || 0));
      })

      this.extranetUIView.start();

      const listSize = this.extranetUIView.getLinkTotal()

      this.extranetUIView.setAddEanble(listSize < (this.extranetSetting.max || 0));
      this.extranetUIView.setDeleteEanble(this.extranetSetting.deleteEnable)
      this.extranetUIView.setEditEanble(this.extranetSetting.editEnable)

      var nodes = this.container.childNodes;
      for(var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute("style",'background-color:white;height:100%')
      }

      this.extranetUIView.running = this.running
      this.extranetUIView.setRunningAnimation(this.device.runningAnimation)
    }
  },
  watch: {
    initData(newValue, oldValue) {
      this.addData(newValue);
    },
    runningAnimation(nvalue,ovalue){
      if(!this.extranetUIView){
        return;
      }
      //this.extranetUIView.setRunningAnimation(nvalue)
    }
  }
}


</script>


<style scoped>

</style>